<script>
  import Orders from "$lib/assets/imgs/Orders@2x.webp";
</script>

<!-- Reversed layout: image LEFT, text RIGHT -->
<section class="mt-28 px-4">
  <div
    class="container mx-auto lg:h-[555px] w-full overflow-hidden bg-white rounded-2xl shadow-sm flex flex-wrap lg:flex-nowrap"
  >
    <!-- Image Side (LEFT on desktop) -->
    <div
      class="lg:w-1/2 p-8 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center order-2 lg:order-1"
    >
      <img
        class="object-contain max-h-full rounded-lg shadow-lg"
        src={Orders}
        alt="Orders Dashboard"
        loading="lazy"
      />
    </div>
    <!-- Text Side (RIGHT on desktop) -->
    <div
      class="lg:w-1/2 p-8 md:p-16 lg:p-20 flex flex-col justify-center order-1 lg:order-2"
    >
      <div
        class="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-sm font-semibold px-4 py-1.5 rounded-full w-fit mb-6"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        Sales Tracking
      </div>
      <h2 class="text-2xl lg:text-4xl font-bold text-gray-900 leading-tight">
        Manage your business
        <span class="text-green-500">online</span>
      </h2>
      <p class="text-gray-600 text-lg mt-4 leading-relaxed max-w-md">
        Track your orders, sales and revenue all in one place. Get real-time
        insights into your business performance.
      </p>
      <ul class="mt-6 space-y-3">
        <li class="flex items-center gap-3 text-gray-700">
          <span
            class="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center"
          >
            <svg
              class="w-3 h-3 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </span>
          Real-time order tracking
        </li>
        <li class="flex items-center gap-3 text-gray-700">
          <span
            class="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center"
          >
            <svg
              class="w-3 h-3 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </span>
          Revenue & sales analytics
        </li>
        <li class="flex items-center gap-3 text-gray-700">
          <span
            class="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center"
          >
            <svg
              class="w-3 h-3 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </span>
          Customer management
        </li>
      </ul>
    </div>
  </div>
</section>
